import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable max-lines */
/* eslint-disable camelcase */
import { useEffect, useState } from "react";
import ReactPaginate from "react-paginate";
import { useCars, useCarsDispatch } from "./CarsContext";
import { CarsFiltration, } from "./CarsFiltrations";
import { CarsToggleButton } from "./CarsFiltrToggleButton";
import { CarCard } from "./CarCard";
import Alert from "../Alert";
import Database from "../Database";
import { removeDiacritics } from "../../utils/remove-diacritics";
import { Helmet } from "react-helmet";
import { sprintf } from "sprintf-js";
import { LandingPageDescription } from "../../types/types";
const itemsPerPage = 12;
const currentDbKey = "carData";
// eslint-disable-next-line complexity
export function Cars(props) {
    console.log("rendering cars");
    const [countCalc, setCountCalc] = useState(0);
    const [openFiltr, setOpenFiltr] = useState(false);
    const [loadedFromDb, setLoadedFromDb] = useState(false);
    const [currentPage, setCurrentPage] = useState(0);
    const [pageTitle, setPageTitle] = useState("Operativní leasingy");
    const [seoPageMetaDesc, setSeoPageMetaDesc] = useState(LandingPageDescription.CATALOGUE);
    const [seoPageContent, setSeoPageContent] = useState("");
    const [breadcrumbData, setBreadcrumbData] = useState([]);
    const { cars, filteredCars } = useCars();
    const dispatch = useCarsDispatch();
    const filterData = document
        .getElementById("cars-react")
        ?.getAttribute("data-filter");
    const parsedFilterData = filterData && JSON.parse(filterData);
    useEffect(() => {
        registerAndLoadFromWorker();
    }, []);
    useEffect(() => {
        // reset first page pagination after filtered cars changed
        setCurrentPage(0);
        if (localStorage.getItem("debug")) {
            // eslint-disable-next-line no-console
            console.log("Filtered cars", filteredCars.length, filteredCars);
        }
        // remove static cars from DOM
        if (filteredCars.length > 0) {
            const removeElement = document.getElementById("js-remove-react");
            if (removeElement) {
                removeElement.remove();
                const container = document.getElementById("cars-react");
                container?.classList.remove("d-none");
            }
        }
    }, [filteredCars]);
    async function saveToDb(dbKey, data) {
        await Database.addCarData(dbKey, data);
    }
    async function loadCarsFromDb() {
        const resultDb = await Database.getCarData(currentDbKey);
        if (resultDb?.carData) {
            const carItems = JSON.parse(resultDb.carData);
            setLoadedFromDb(true);
            dispatch({
                type: "setCars",
                cars: carItems,
            });
        }
    }
    function checkDoesntNeedUpdate() {
        const currentDate = new Date().toLocaleDateString("en-US");
        if (!localStorage.getItem("lastUpdate") ||
            localStorage.getItem("lastUpdate") !== currentDate) {
            localStorage.setItem("lastUpdate", currentDate);
            return false;
        }
        return true;
    }
    async function registerAndLoadFromWorker() {
        if (!navigator.serviceWorker) {
            Alert.error("Váš prohlížeč je zastaralý, aktualizujte jej prosím...");
            return;
        }
        const randomString = Math.random().toString(36).substring(2, 15);
        await Database.openDb();
        if (checkDoesntNeedUpdate()) {
            await loadCarsFromDb();
        }
        navigator.serviceWorker
            .register("/js/service-worker.js?v=" + randomString)
            .then(() => {
            const worker = new Worker("/js/service-worker.js?v=" + randomString);
            worker.postMessage({
                action: "loadData",
                endpoint: document.body.getAttribute("data-storage-bucket"),
            });
            worker.addEventListener("message", (event) => {
                setCountCalc(event.data.countCalc);
                const data = event.data.result;
                saveToDb(currentDbKey, JSON.stringify(data));
                if (!loadedFromDb) {
                    dispatch({
                        type: "setCars",
                        cars: data,
                    });
                }
            });
        }, (err) => {
            // eslint-disable-next-line no-console
            console.error("ServiceWorker registration failed: ", err);
        });
    }
    function handlePageClick(event) {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
        setCurrentPage(event.selected);
    }
    async function fetchCarTexts() {
        const endpoint = document.body.getAttribute("data-storage-bucket");
        const result = await fetch(`${endpoint}/json/carTexts.json?hash=${Math.random()}`);
        const responseBody = await result.text();
        return await JSON.parse(responseBody);
    }
    // eslint-disable-next-line complexity
    async function onFilterChange({ manufacValue, mdlValue, eqpLevValue, }) {
        let metaDesc = LandingPageDescription.CATALOGUE;
        let content = "";
        let breadcrumbs = [];
        const seoPageUrlSlug = "/operativni-leasing";
        const carTexts = await fetchCarTexts();
        breadcrumbs = [
            { title: "Úvod", urlSlug: "/" },
            {
                title: "Celá nabídka",
                urlSlug: "/nabidka-operativniho-leasingu",
            },
        ];
        // TODO: jakmile budou pageTexty a metaDescriptiony pro všechny kombinace, tak odebrat otazníky a prázdné stringy z dat pro pageText a metaDescription
        if (Array.isArray(manufacValue) && manufacValue.length === 1) {
            const manufacturer = manufacValue[0];
            metaDesc = sprintf(LandingPageDescription.MANUFACTURER, manufacturer);
            content = carTexts[manufacturer]?.text ?? "";
            breadcrumbs = [
                { title: "Úvod", urlSlug: "/" },
                {
                    title: "Celá nabídka",
                    urlSlug: "/nabidka-operativniho-leasingu",
                },
                {
                    title: manufacturer,
                    urlSlug: "#",
                },
            ];
            if (Array.isArray(mdlValue)) {
                if (mdlValue.length > 0
                    || (mdlValue.length === 0 && Array.isArray(eqpLevValue) && eqpLevValue.length > 0)) {
                    if (mdlValue.length === 1) {
                        const model = mdlValue[0];
                        metaDesc = sprintf(LandingPageDescription.MODEL, manufacturer, model);
                        content = carTexts[manufacturer]?.models[model]?.text ?? "";
                        breadcrumbs = [
                            { title: "Úvod", urlSlug: "/" },
                            {
                                title: "Celá nabídka",
                                urlSlug: "/nabidka-operativniho-leasingu",
                            },
                            {
                                title: manufacturer,
                                urlSlug: `${seoPageUrlSlug}/${removeDiacritics(manufacturer)}`,
                            },
                            {
                                title: model,
                                urlSlug: "#",
                            },
                        ];
                        if (Array.isArray(eqpLevValue)) {
                            if (eqpLevValue.length > 0) {
                                metaDesc = LandingPageDescription.CATALOGUE;
                                content = "";
                            }
                            if (eqpLevValue.length === 1) {
                                const equipmentLevel = eqpLevValue[0];
                                metaDesc = sprintf(LandingPageDescription.EQUIPMENT_LEVEL, manufacturer, model, equipmentLevel);
                                content = carTexts[manufacturer]?.models[model]?.equipmentLevels[equipmentLevel]?.text ?? "";
                                breadcrumbs = [
                                    { title: "Úvod", urlSlug: "/" },
                                    {
                                        title: "Celá nabídka",
                                        urlSlug: "/nabidka-operativniho-leasingu",
                                    },
                                    {
                                        title: manufacturer,
                                        urlSlug: `${seoPageUrlSlug}/${removeDiacritics(manufacturer)}`,
                                    },
                                    {
                                        title: model,
                                        urlSlug: `${seoPageUrlSlug}/${removeDiacritics(manufacturer)}-${removeDiacritics(model)}`,
                                    },
                                    {
                                        title: equipmentLevel === "Žádný" ? "Standardní výbava" : equipmentLevel,
                                        urlSlug: "#",
                                    },
                                ];
                            }
                        }
                    }
                }
            }
        }
        setBreadcrumbData(breadcrumbs);
        setSeoPageContent(content);
        setSeoPageMetaDesc(metaDesc);
    }
    const breadcrumbSeparator = ">";
    const offset = (currentPage * itemsPerPage) % filteredCars.length;
    const endOffset = offset + itemsPerPage;
    const currentItems = filteredCars.slice(offset, endOffset);
    const pageCount = Math.ceil(filteredCars.length / itemsPerPage);
    return (_jsxs(_Fragment, { children: [_jsx("div", { className: "mb-max-lg-4", children: _jsx("div", { className: "breadcrumbs", children: breadcrumbData.map((breadcrumb, index) => (_jsxs(_Fragment, { children: [index > 0 && (_jsx("span", { className: "breadcrumbs__separator", children: breadcrumbSeparator })), _jsx("a", { className: "breadcrumbs__item", href: breadcrumb.urlSlug, children: breadcrumb.title })] }))) }) }), _jsx(CarsToggleButton, { cars: filteredCars.length, value: openFiltr, valueChanged: (isOpen) => setOpenFiltr(isOpen) }), _jsx("div", { className: "cars-page-wrapper", children: _jsxs("div", { className: "cars-wrapper", children: [_jsxs("div", { className: openFiltr ? "cars-side cars-side--open" : "cars-side", children: [_jsx("div", { className: "cars-side__wrapper", children: _jsx(CarsFiltration, { initialFilterData: parsedFilterData, updatePageTitle: setPageTitle, filtersChanged: onFilterChange }) }), _jsx(CarsToggleButton, { cars: filteredCars.length, value: openFiltr, valueChanged: (isOpen) => setOpenFiltr(isOpen) })] }), _jsxs("div", { className: "cars-content", children: [currentItems.length > 0 && (_jsxs(_Fragment, { children: [_jsx(Helmet, { onChangeClientState: (newState) => {
                                                const ogTitle = document.querySelector('meta[property="og:title"]');
                                                const description = document.querySelector('meta[name="description"]');
                                                const twitterDescription = document.querySelector('meta[name="twitter:description"]');
                                                const ogDescription = document.querySelector('meta[property="og:description"]');
                                                if (ogTitle) {
                                                    ogTitle.setAttribute('content', pageTitle + " | sOperák.cz");
                                                }
                                                if (description) {
                                                    description.setAttribute('content', seoPageMetaDesc);
                                                }
                                                if (twitterDescription) {
                                                    twitterDescription.setAttribute('content', seoPageMetaDesc);
                                                }
                                                if (ogDescription) {
                                                    ogDescription.setAttribute('content', seoPageMetaDesc);
                                                }
                                            }, children: _jsxs("title", { children: [pageTitle, " | sOper\u00E1k.cz"] }) }), _jsx("h1", { className: "headline headline--h1", children: pageTitle })] })), _jsx("div", { className: "car-list", children: currentItems && currentItems.map((car, index) => (_jsx(CarCard, { carIndex: index, car: car }, index))) }), currentItems.length === 0 && cars.length > 0 && (_jsxs("div", { className: "info-box", children: [_jsx("p", { className: "info-box__headline", children: "Omlouv\u00E1me se" }), _jsx("h1", { className: "info-box__main-headline headline headline--h1", children: pageTitle }), _jsx("p", { className: "info-box__headline", children: "neexistuje" }), _jsx("p", { className: "info-box__text", children: "Dal\u0161\u00ED mo\u017Enosti leasing\u016F naleznete v nab\u00EDdce oper\u00E1k\u016F nebo \u00FApravou filtrace" }), _jsx("a", { className: "info-box__btn btn btn--primary", href: "/nabidka-operativniho-leasingu", children: "Zp\u011Bt do nab\u00EDdky oper\u00E1k\u016F" })] })), filteredCars.length > itemsPerPage && (_jsx(ReactPaginate, { breakLabel: "...", nextLabel: ">", containerClassName: "car-pag", pageClassName: "car-pag__item", breakClassName: "car-pag__item car-pag__dots", previousClassName: "car-pag__item car-pag__item--previous", nextClassName: "car-pag__item car-pag__item--next", disabledLinkClassName: "car-pag__item car-pag__item--disabled", activeClassName: "car-pag__item car-pag__item--active", onPageChange: handlePageClick, pageRangeDisplayed: 5, forcePage: currentPage, pageCount: pageCount, previousLabel: "<" })), seoPageContent !== "" && currentItems.length > 0 && (_jsx("div", { className: "seo-page-text", dangerouslySetInnerHTML: { __html: seoPageContent } }))] })] }) })] }));
}
